/**
 * 한글 NFD(Normalization Form Decomposed) 카운트 계산
 * 한글 자모를 분리하여 실제 키 입력 횟수를 계산
 * 예: "가" -> "ㄱ" + "ㅏ" = 2
 */
export const calculateNFDCount = (text: string): number => {
  if (!text) return 0;

  // NFD로 정규화하여 한글 자모 분리
  const normalized = text.normalize('NFD');
  return normalized.length;
};